<template>
  <div>
    <b-form
      novalidate
      @submit.prevent="submit"
    >
      <validation-observer ref="formRef">
        <b-card>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Name English"
                rules="required"
              >
                <b-form-group
                  label="Name English"
                  label-for="tag-name-en"
                >
                  <b-form-input
                    id="tag-name-en"
                    v-model="formData.name.en"
                    placeholder="English Name"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Name Arabic"
                rules="required"
              >
                <b-form-group
                  label="Name Arabic"
                  label-for="tag-name-ar"
                >
                  <b-form-input
                    id="tag-name-ar"
                    v-model="formData.name.ar"
                    placeholder="Arabic Name"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Description English"
                rules="required"
              >
                <b-form-group
                  label="Description English"
                  label-for="tag-desc-en"
                >
                  <b-form-textarea
                    id="tag-desc-en"
                    v-model="formData.description.en"
                    placeholder="English Description"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Description Arabic"
                rules="required"
              >
                <b-form-group
                  label="Description Arabic"
                  label-for="tag-desc-ar"
                >
                  <b-form-textarea
                    id="tag-desc-ar"
                    v-model="formData.description.ar"
                    placeholder="Arabic Description"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Image"
                :rules="`${tag ? '' : 'required'}`"
              >
                <b-form-group label="Image">
                  <b-form-file
                    v-model="file"
                    accept="image/*"
                    @change="fileChangeHandler"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Order"
                rules="required"
              >
                <b-form-group
                  label="Order"
                  label-for="tag-order"
                >
                  <b-form-input
                    id="tag-order"
                    v-model="formData.order"
                    placeholder="Order"
                    type="number"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="6"
              class="d-flex align-items-center justify-content-center"
            >
              <b-button
                block
                variant="primary"
                type="submit"
                :disabled="submitting"
              >
                <b-spinner
                  v-if="submitting"
                  small
                />
                <span v-else>{{ tag ? 'Update' : 'Save' }}</span>
              </b-button>
            </b-col>
            <b-col
              v-if="tagImageUrl"
              class="d-flex justify-content-end align-items-center"
              md="6"
            >
              <h6 class="mr-1">
                Uploaded Tag Image
              </h6>
              <a
                :href="tagImageUrl"
                target="_blank"
              >
                <b-avatar
                  :src="tagImageUrl"
                  size="50"
                />
              </a>
            </b-col>
          </b-row>
        </b-card>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BSpinner,
  BFormTextarea,
  BFormFile,
  BAvatar,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import axios from 'axios'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BCard,
    BForm,
    BFormInput,
    BSpinner,
    BFormFile,
    BAvatar,
    ValidationProvider,
    BButton,
    ValidationObserver,
    BFormGroup,
    BRow,
    BCol,
    BFormTextarea,
  },
  props: {
    tag: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const formData = ref({
      name: {
        en: '',
        ar: '',
      },
      description: {
        en: '',
        ar: '',
      },
      order: null,
      imageKey: null,
    })
    const submitting = ref(false)
    const formRef = ref(null)
    const file = ref(null)
    const tagImageUrl = ref('')

    const submit = async () => {
      try {
        submitting.value = true
        const res = await formRef.value.validate()
        if (!res) return
        if (!props.tag) {
          await ctx.root.$store.dispatch('business/createTag', formData.value)
        } else {
          await ctx.root.$store.dispatch('business/updateTag', {
            id: formData.value.id,
            payload: {
              name: formData.value.name,
              description: formData.value.description,
              order: formData.value.order,
              imageKey: formData.value.imageKey || undefined,
            },
          })
        }
        ctx.root.$bvModal.hide('businesses-tag-modal')
        ctx.emit('refetch')
      } finally {
        submitting.value = false
      }
    }
    const fileChangeHandler = async ev => {
      try {
        submitting.value = true
        const fileValue = ev.target.files[0]
        const presignedRes = await axiosIns.get('/businesses/tags/image-presigned-url')
        const { url, key } = presignedRes.data.data
        formData.value.imageKey = key
        await axios.put(url, fileValue)
      } finally {
        submitting.value = false
      }
    }

    if (props.tag) {
      formData.value = { ...props.tag }
      tagImageUrl.value = props.tag.imageUrl
    }
    return {
      fileChangeHandler,
      submit,
      submitting,
      formRef,
      required,
      formData,
      file,
      tagImageUrl,
    }
  },
}
</script>

<style>

</style>
